import { showToast } from "../../../utils/styles/toastUtils";
import { postResetPasswordApi } from "../../apis/auth/postResetPasswordApi";
import * as types from "../ActionTypes";

export const ResetPasswordActionStart = () => ({
    type: types.POST_RESET_PASSWORD_START,
});

export const ResetPasswordActionSuccess = (data) => ({
    type: types.POST_RESET_PASSWORD_SUCCESS,
    payload: data,
});

export const ResetPasswordActionError = (error) => ({
    type: types.POST_RESET_PASSWORD_ERROR,
    payload: error,
});

export const ResetPasswordActionInitiate = (data) => {
    return async function (dispatch) {
        dispatch(ResetPasswordActionStart());

        try {
            const res = await postResetPasswordApi(data);
            const responseData = res.data;

            dispatch(ResetPasswordActionSuccess(responseData));

            if (responseData.success) {
                if (responseData.message) {
                    showToast.success(responseData.message);
                }
            }

            return { success: true, data: responseData };

        } catch (error) {
            const errorMessage = error.response?.data?.error || error.response?.data?.message || "Something went wrong";
            if (errorMessage) {
                showToast.error(errorMessage);
            }
            console.error("ResetPasswordActionError", error);
            dispatch(ResetPasswordActionError(error.message));
            return { success: false, error };
        }
    };
};
